import type { AlternativeCatalogOption, CatalogOption } from '@/types/catalog'

function catalogTime(catalog: CatalogOption): number {
  return Date.parse(catalog.effectiveAt)
}

function requireCatalog(catalogs: CatalogOption[]): CatalogOption {
  const catalog = catalogs[0]
  if (!catalog) throw new Error('No catalogs found in index.json')
  return catalog
}

export function sortCatalogs(catalogs: CatalogOption[]): CatalogOption[] {
  return [...catalogs].sort((a, b) => catalogTime(a) - catalogTime(b))
}

export function selectCurrentCatalog(
  catalogs: CatalogOption[],
  now = Date.now(),
): CatalogOption {
  const sortedCatalogs = sortCatalogs(catalogs)
  const current = sortedCatalogs.filter(catalog => catalogTime(catalog) <= now).at(-1)
  return current ?? requireCatalog(sortedCatalogs)
}

export function selectLatestCatalog(catalogs: CatalogOption[]): CatalogOption {
  const sortedCatalogs = sortCatalogs(catalogs)
  return sortedCatalogs.at(-1) ?? requireCatalog(sortedCatalogs)
}

export function createAlternativeCatalogs(
  catalogs: CatalogOption[],
  currentCatalog: CatalogOption,
): AlternativeCatalogOption[] {
  const sortedCatalogs = sortCatalogs(catalogs)
  const currentIndex = sortedCatalogs.findIndex(catalog => catalog.path === currentCatalog.path)

  return sortedCatalogs.flatMap((catalog, index) => {
    if (index === currentIndex) return []
    const period = index < currentIndex ? 'past' : 'future'
    return [{
      ...catalog,
      period,
      boundaryAt: period === 'past'
        ? sortedCatalogs[index + 1]?.effectiveAt ?? catalog.effectiveAt
        : catalog.effectiveAt,
    }]
  })
}
